import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: '[app-sorted-arrow]',
  templateUrl: './sorted-arrow.component.html',
  styleUrls: ['./sorted-arrow.component.css']
})
export class SortedArrowComponent implements OnInit {

  @Input() isAscending: boolean = true;
  constructor() { }

  ngOnInit() {

  }

}
